import React, { Suspense } from "react";
import { StoreInformation } from "~/modules/store-information/store-information";
import { Await, useLoaderData } from "@remix-run/react";

export default function Index() {
  const { partner } = useLoaderData();
  return (
    <Suspense fallback={<></>}>
      <Await resolve={partner} errorElement={<p>Error</p>}>
        {(p) => <StoreInformation partner={p} />}
      </Await>
    </Suspense>
  );
}
